<template>
  <div class="min-h-[80vh] flex items-center justify-center px-4 py-12">
    <div class="w-full max-w-md">
      <!-- Logo/Branding -->
      <div class="text-center mb-8">
        <h1 class="text-3xl font-bold text-gray-800 mb-2"><SiteBrandName /></h1>
        <p class="text-gray-600">{{ $t('auth.welcomeMessage') }}</p>
      </div>

      <!-- Login Card -->
      <div class="bg-white rounded-lg shadow-md p-8">
        <!--h2 class="text-2xl font-semibold text-gray-800 mb-6 text-center">
          {{ $t('auth.signIn') }}
        </h2-->
        
        <LoginForm @success="handleLoginSuccess" />
      </div>

      <!-- Back to Home -->
      <div class="mt-6 text-center">
        <router-link 
          to="/" 
          class="text-sm text-gray-600 hover:text-blue-600 transition inline-flex items-center gap-2"
        >
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          {{ $t('auth.backToHome') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import LoginForm from '../components/auth/LoginForm.vue';
import SiteBrandName from '../components/common/SiteBrandName.vue';
import { authStore } from '../stores/auth';

const router = useRouter();

// If already logged in with a routable role, redirect; pending/deleted stay on this page.
onMounted(() => {
  if (authStore.isAuthenticated) {
    if (authStore.isAdmin) {
      router.push('/admin');
    } else if (authStore.isTenant) {
      router.push('/dashboard');
    }
  }
});

function handleLoginSuccess() {
  // LoginForm handles navigation; pending/deleted users remain here.
}
</script>

